export const BEEKEEPER = 'beekeeper';
export const SPEAKAP = 'speakap';
export const ITERABLE = 'iterable';
export const BRAZE = 'braze';
export const MS_TEAMS = 'msTeams';
export const ONE_GROUP_INTEGRATIONS = [BEEKEEPER];
export const RIPPLING = 'rippling';
export const DAYFORCE = 'dayforce';
export const WORKDAY = 'workday';
export const MICROSOFT_ENTRA_ID = 'microsoftEntraId';
export const GOOGLE_DRIVE = 'googleDrive';
export const SHAREPOINT = 'sharepoint';
export const DROPBOX = 'dropbox';
export const BOX = 'box';
export const ONEDRIVE = 'onedrive';
export const SALESFORCE = 'salesforce';
export const HUBSPOT = 'hubspot';
export const SAP_SUCCESS_FACTORS = 'sapSuccessfactors';

// Used for MSTeams trials that do not have a company name
export const MS_TEAMS_DEFAULT_COMPANY_NAME = 'New company';

export const USER_IDENTIFICATION_KEY_BEEKEEPER = 'beekeeper.employeeId';

export const INTEGRATION_DISPLAY_NAMES = {
  [MS_TEAMS]: 'Microsoft Teams',
  [RIPPLING]: 'Rippling',
  [DAYFORCE]: 'Dayforce',
  [WORKDAY]: 'Workday',
  [MICROSOFT_ENTRA_ID]: 'Microsoft Entra ID',
  [GOOGLE_DRIVE]: 'Google Drive',
  [SHAREPOINT]: 'SharePoint',
  [DROPBOX]: 'Dropbox',
  [BOX]: 'Box',
  [ONEDRIVE]: 'OneDrive',
  [SALESFORCE]: 'Salesforce',
  [HUBSPOT]: 'HubSpot',
  [SAP_SUCCESS_FACTORS]: 'SAP SuccessFactors',
};

export const FILE_STORAGE_INTEGRATION_TYPES = [
  GOOGLE_DRIVE,
  SHAREPOINT,
  DROPBOX,
  BOX,
  ONEDRIVE,
] as const;

export const HRIS_INTEGRATION_TYPES = [
  WORKDAY,
  MICROSOFT_ENTRA_ID,
  DAYFORCE,
  RIPPLING,
  SAP_SUCCESS_FACTORS,
] as const;

export const CRM_INTEGRATION_TYPES = [SALESFORCE, HUBSPOT] as const;

export const MERGE_INTEGRATION_CATEGORY_MAP = {
  ...Object.fromEntries(
    FILE_STORAGE_INTEGRATION_TYPES.map((type) => [type, 'filestorage'])
  ),
  ...Object.fromEntries(HRIS_INTEGRATION_TYPES.map((type) => [type, 'hris'])),
  ...Object.fromEntries(CRM_INTEGRATION_TYPES.map((type) => [type, 'crm'])),
};

// TODO: rename to merge_integration_types
export const INTEGRATION_TYPES = [
  ...FILE_STORAGE_INTEGRATION_TYPES,
  ...HRIS_INTEGRATION_TYPES,
  ...CRM_INTEGRATION_TYPES,
] as const;
